export default __webpack_public_path__ + "static/media/kitchen3-before3-1440w.5fe75f9a.webp";